import React from "react";
import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-200 px-6" data-testid="unauthorized-page">
      <div className="text-center max-w-md">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500/80 mb-3">401</p>
        <h1 className="text-4xl font-semibold tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>You don't have access</h1>
        <p className="mt-3 text-zinc-400">Ask your workspace Owner to grant you access to this section.</p>
        <Link to="/dashboard" className="inline-block mt-6 bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg text-sm font-medium" data-testid="unauthorized-back-btn">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
